import { useCallback } from 'react';
import useSWRMutation from 'swr/mutation';

import { SwrApiTriggerOptions } from 'types/api';
import { useSWRAxiosMutation } from 'hooks/useSWRAxiosMutation';
import { createUserProvenancesUrl } from 'constants/urls';
import { ProvenanceInfo } from 'types/provenance';

export const useAddUserProvenance = () => {
    const { post } = useSWRAxiosMutation();

    const addProvenanceRequest = (_: string, { arg }: { arg: { userID: string; provenanceInfo?: ProvenanceInfo } }) =>
        post(createUserProvenancesUrl(arg.userID), arg.provenanceInfo);

    const { trigger, isMutating, error } = useSWRMutation('url', addProvenanceRequest);

    const addUserProvenance = useCallback(
        async (userID?: string, newProvenance?: ProvenanceInfo, options?: SwrApiTriggerOptions<object>) => {
            if (!userID || !newProvenance) {
                return;
            }
            await trigger(
                {
                    userID,
                    provenanceInfo: newProvenance
                },
                {
                    optimisticData: currentData => currentData,
                    populateCache: (_, currentData) => currentData,
                    revalidate: false,
                    rollbackOnError: true,
                    throwOnError: false,
                    ...options
                }
            );
        },
        []
    );

    return {
        addUserProvenance,
        isMutating,
        error: error?.response?.data
    };
};
